var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.as || _vm.name + '-icon',{tag:"component",class:_vm.classes,nativeOn:{"click":function($event){return _vm.click.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }